import AppSelectors from "../Ducks/App/selectors";
import {createSelector} from "reselect";
import CurrentRideSelectors from "../Ducks/CurrentRide/selectors";
import TokenDataSelectors from "../Ducks/TokenData/selectors";
import CurrentProposalSelectors from "../Ducks/CurrentProposal/selectors";
import {LatLngEnum, RideStatus} from "../../Utils/AppUtils";
import CurrentRequestSelectors from "../Ducks/CurrentRequest/selectors";
import {StopSelection} from "../Ducks/CurrentRequest/utils";

const showLoading = createSelector(
    AppSelectors.appSelector,

    (app) => {
        return app.loadingSemaphore && app.loadingSemaphore > 0;
    }
);

const shouldShowAlert = createSelector(
    AppSelectors.appSelector,
    (app) => {
        return !!app.alert;
    }
);
const shouldShowWelcomeScreen = createSelector(
    AppSelectors.appSelector,
    CurrentRideSelectors.isConcreteRide,
    (app, concreteRide) => {
        return !app.isInIframe && !app.acceptedTerms && !concreteRide;
    },
);

const shouldShowRideRequest = createSelector(
    CurrentProposalSelectors.canRequestRide,

    (requestRide) => {
        return !!requestRide;
    },
);

const shouldShowRide = createSelector(
    CurrentRideSelectors.isConcreteRide,
    (concreteRide) => {
        return !!concreteRide;
    }
);


const shouldShowProposal = createSelector(
    CurrentProposalSelectors.isConcreteProposal,
    CurrentProposalSelectors.shouldRequestProposal,
    shouldShowRide,

    (showProposalDetails, shouldRequestProposal, showingRide) => {
        return (showProposalDetails || shouldRequestProposal) && !showingRide;
    },
);

const shouldShowSelectDest = createSelector(
    CurrentProposalSelectors.canRequestDest,
    (requestDest) => {
        return !!requestDest;
    },
);


const shouldShowSelectFreeDest = createSelector(
    shouldShowSelectDest,
    TokenDataSelectors.tokenDataSelector,
    CurrentRequestSelectors.currentRequestSelector,

    (showSelectDest, tokenData, currentRequest) => {
        return showSelectDest && tokenData.dest_type === LatLngEnum.CENTER_ONLY && !currentRequest.dest_search;
    }
);


const shouldShowSelectOrigin = createSelector(
    CurrentProposalSelectors.canRequestOrigin,
    (requestOrigin) => {
        return !!requestOrigin;
    },
);

const shouldShowSelectFreeOrigin = createSelector(
    shouldShowSelectOrigin,
    TokenDataSelectors.tokenDataSelector,
    CurrentRequestSelectors.currentRequestSelector,

    (showSelectOrigin, tokenData, currentRequest) =>
        showSelectOrigin && tokenData.origin_type === LatLngEnum.CENTER_ONLY && !currentRequest.origin_search
);

const shouldShowSelectTerminalOrigin = createSelector(
    shouldShowSelectOrigin,
    CurrentRequestSelectors.getOriginAirportTerminals,
    CurrentRequestSelectors.getOrigin,
    (showSelectOrigin, originTerminals, origin) => {
        return showSelectOrigin && originTerminals && (originTerminals.length > 0) && (origin.selection !== StopSelection.MANUAL);
    }
);

const shouldShowSelectTerminalDest = createSelector(
    shouldShowSelectDest,
    CurrentRequestSelectors.getDestAirportTerminals,
    CurrentRequestSelectors.getDest,
    (showSelectDest, destTerminals, dest) => {
        return showSelectDest && destTerminals && (destTerminals.length > 0) && (dest.selection !== StopSelection.MANUAL);
    }
);
const shouldShowSearchDest = createSelector(
    CurrentRequestSelectors.isSearchingDest,

    (searchingDest) => {
        return searchingDest;
    },
);

const shouldShowSearchOrigin = createSelector(
    CurrentRequestSelectors.isSearchingOrigin,

    (searchingOrigin) => {
        return searchingOrigin;
    },
);

const shouldShowAwaitingDriverApproval = createSelector(
    CurrentRideSelectors.currentRideSelector,
    shouldShowRide,
    (currentRide, showingRide) => {
        return showingRide && currentRide.awaitingDriverApproval;
    }
);

const shouldShowMap = createSelector(
    shouldShowWelcomeScreen,
    CurrentRideSelectors.getRideStatus,
    (showingWelcomeScreen, rideStatus) => {
        return (!showingWelcomeScreen && rideStatus < RideStatus.FINISHED);
    }
);

const shouldShowCancelButton = createSelector(
    CurrentProposalSelectors.isConcreteProposal,
    CurrentRideSelectors.getRideStatus,
    CurrentRideSelectors.isConcreteRide,
    (isProposal, rideStatus, concreteRide) => {
        return ((isProposal && !concreteRide) || rideStatus === RideStatus.ACCEPTED);
    }
);

const shouldShowAwaitingForDriver = createSelector(
    CurrentRideSelectors.isAwaitingDriverApproval,
    (awaitingDriver) => {
        return awaitingDriver;
    }
);

const shouldShowOverlay = createSelector(
    showLoading,
    shouldShowAlert,
    shouldShowAwaitingForDriver,
    (isSpinner, isAlert, awaitingDriver) => {
        return isSpinner || isAlert || awaitingDriver;
    },
);

const shouldShowBlockingError = createSelector(
    AppSelectors.isTechnicalIssue,
    (technicalIssue) => {
        return technicalIssue;
    },
);

const shouldShowCancelTerminalSelection = createSelector(
    shouldShowSelectTerminalOrigin,
    TokenDataSelectors.isOriginForcePolygon,
    shouldShowSelectTerminalDest,
    TokenDataSelectors.isDestForcePolygon,
    (showingOriginTerminals, forcingOriginPolygon, showingDestTerminals, forcingDestPolygon) => {
        return (showingOriginTerminals && !forcingOriginPolygon) || (showingDestTerminals && !forcingDestPolygon);
    },
);

const shouldShowTokenError = createSelector(
    TokenDataSelectors.isTokenDataInvalid,
    (tokenInvalid) => {
        return !!tokenInvalid;
    },
);

export default {
    showLoading,
    shouldShowOverlay,
    shouldShowAlert,
    shouldShowWelcomeScreen,
    shouldShowRideRequest,
    shouldShowProposal,
    shouldShowRide,
    shouldShowSelectDest,
    shouldShowSelectOrigin,
    shouldShowSelectFreeDest,
    shouldShowSelectFreeOrigin,
    shouldShowSelectTerminalDest,
    shouldShowSelectTerminalOrigin,
    shouldShowSearchDest,
    shouldShowSearchOrigin,
    shouldShowAwaitingDriverApproval,
    shouldShowMap,
    shouldShowCancelButton,
    shouldShowAwaitingForDriver,
    shouldShowBlockingError,
    shouldShowCancelTerminalSelection,
    shouldShowTokenError,
};



// WEBPACK FOOTER //
// ./src/Store/Views/screens.js